import css from './styles.module.scss';

// Ключ = decoration_id из bingoRating.json. Осенняя тройка выдаётся ивентами,
// одновременно активен ровно один id — какой именно, решает сид на бэкенде.
export const plateRegistry: Record<string, string> = {
  purplePlate: css.purplePlate,
  summerPlate: css.summerPlate,
  lagoonPlate: css.lagoonPlate,
  autumnPlate: css.autumnPlate,
  drizzlePlate: css.drizzlePlate,
  pumpkinPlate: css.pumpkinPlate,
};

// Названия скинов живут здесь, а не на бэкенде: сервер отдаёт только id,
// поэтому новый скин — это правка одного фронта. Значения — ключи i18n.
const plateTitles: Record<string, string> = {
  purplePlate: 'Purple',
  summerPlate: 'Summer',
  lagoonPlate: 'Lagoon',
  autumnPlate: 'Golden Autumn',
  drizzlePlate: 'November Rain',
  pumpkinPlate: 'Pumpkin Night',
};

// Пустой decorationId — «скин не надет», строка рейтинга рисуется дефолтом.
export const NO_DECORATION_ID = '';
export const NO_DECORATION_TITLE = 'Standard';
export const getDecorationClass = (
  decorationId: string | undefined,
): string | undefined => {
  if (!decorationId) return undefined;

  return plateRegistry[decorationId];
};
// Неизвестный id (например, ивент выкатили на бэкенде раньше фронта) не
// должен рисовать пустую строку в настройках — показываем сам id.
export const getDecorationTitleKey = (decorationId: string): string =>
  plateTitles[decorationId] ?? decorationId;
